import React, { useCallback, useEffect, useRef, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterFeature,
  Weapon,
  WeaponMasteryFeature,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import DataUtilities from '@dndUtilities/data_utilities';

import CharacterListOptionsInput from "@dndComponents/character/misc/CharacterListOptionsInput";
import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";

interface Props {
  character: Character;
  obj: CharacterFeature;
  onChange: (changed: CharacterFeature) => void;
}

const char_util = DandDCharacterUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function CharacterWeaponMasteriesBox({
  character,
  obj,
  onChange,
}: Props) {
  const fos = obj.feature_options as string[];
  const [reloading, setReloading] = useState(false);
  const [show_description, setShowDescription] = useState(false);
  const [selected, setSelected] = useState<string[]>(fos.filter(o => o !== ""));
  const [select_changed, setSelectChanged] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback(() => {
    setReloading(true);
  }, [setReloading]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  useEffect(() => {
    character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
  }, [character, mounted, recalculated]);

  useEffect(() => {
    if (select_changed) {
      setSelectChanged(false);
      const new_obj = obj;
      const new_feature_options = [...selected];
      while (new_feature_options.length < new_obj.feature_options.length) {
        new_feature_options.push("");
      }
      new_obj.feature_options = new_feature_options;
      onChange(new_obj);
    }
  }, [obj, selected, onChange, select_changed]);
  
  console.log(character.weapon_masteries);
  return (
    <Grid container spacing={0} direction="row">
      <Grid size={12} className="header centered">{ obj.name }</Grid>
      <Grid size={12}>
        <ToggleButtonBox
          name="Show Description"
          value={show_description}
          onToggle={() => { setShowDescription(!show_description); }}
        />
      </Grid>
      { show_description &&
        <Grid size={12}>
          <DisplayStringWithReplacements display_string={obj.description} cfs={character} />
        </Grid>
      }
      <Grid size={12}>
        <CharacterListOptionsInput
          data_type="item"
          filter={{ item_type: "Weapon" }}
          char={character}
          choose_max={fos.length} 
          selected={selected} 
          // log_it
          selected_elsewhere={character.standard_weapon_mastery_weapons.filter(o => !selected.includes(o))} 
          onChange={(changed: string[]) => {
            // debugger;
            setSelected(changed);
            setSelectChanged(true);
          }} 
          getName={(weapon) => {
            if (weapon instanceof Weapon) {
              const wmp = data_util.weapon_mastery_properties.find(o => o._id === weapon.weapon_mastery_property_id);
              if (wmp) {
                return `${weapon.name} (${wmp.name})`;
              }
            }
            return weapon.name;
          }}
          getDetails={(weapon) => {
            if (weapon instanceof Weapon) {
              const wmp = data_util.weapon_mastery_properties.find(o => o._id === weapon.weapon_mastery_property_id);
              if (wmp) {
                return wmp.description;
              }
            }
            return "";
          }}
          getDisabledReasons={(weapon) => {
            // if (weapon.name.includes("Hand") && weapon.name.includes("Crossbow")) {
            //   debugger;
            // }
            if (weapon instanceof Weapon && obj.floating_feature instanceof WeaponMasteryFeature) {
              if (!char_util.fitCharWeaponLimit(character, weapon, obj.floating_feature.weapon_limit)) {
                return "Doesn't Fit Limits";
              }
            }
            return "";
          }}
        />
      </Grid>
    </Grid>
  );
}
